import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const isRejectedAction = (action) => {
  return action.type.endsWith('/rejected');
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    items: []
  },
  reducers: {
    addNotification: (state, action) => {
      const newNotification = { ...action.payload, notificationId: uuidv4() };

      state.items = state.items
        .filter((i) => i.notificationId !== action.payload?.notificationId)
        .filter((i) => i.identifier !== action.payload?.identifier)
        .concat(newNotification);
    },
    removeNotification: (state, action) => {
      state.items = state.items
        .filter((i) => i.notificationId !== action.payload)
        .filter((i) => i.identifier !== action.payload);
    },
    clearNotifications: (state) => {
      state.items = [];
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRejectedAction, (state, action) => {
      if (action.payload?.notify === false) return;
      
      const actionLabel = action?.type?.split('/')?.[0] || null;
      const localizationKey = action.payload?.key || action.payload?.code;
      const message =
        action.payload?.message ||
        action.payload?.errors?.message ||
        action.payload;

      if (message && !state.items.find((i) => i.title === message)) {
        const content = {
          identifier: actionLabel || null,
          content: localizationKey || message || 'general.error',
          notificationId: uuidv4(),
          localize: !!localizationKey,
          variant: 'danger'
        };

        state.items = state.items
          .filter((i) => i.notificationId !== content?.notificationId)
          .filter((i) => i.identifier !== content?.identifier)
          .concat(content);
      }
    });
  }
});

export default notificationSlice.reducer;
export const { addNotification, removeNotification, clearNotifications } =
  notificationSlice.actions;
